import { RESEND_PAYMENT_SELECTED } from './payment.types';

export const resendPaymentSelected = transactionId => ({
  type: RESEND_PAYMENT_SELECTED,
  payload: { transactionId },
});
